import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13bbb5cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "card-title"
}
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_3, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("main", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})